import { PURGE } from "redux-persist"

import { types } from "./account.actions"

export const initialState = {
  isLoading: false,
  isAuthenticated: false,
  hasResetPassword: false,
  magicLinkSent: false,
  token: "",
  error: ""
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PURGE:
      return initialState

    case types.TOKEN_SIGN_IN:
      return { ...state, isLoading: true }

    case types.SIGN_IN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: !!action.payload,
        token: action.payload || ""
      }

    case types.SEND_MAGIC_LINK_FAIL:
    case types.SIGN_IN_FAIL:
    case types.TOKEN_SIGN_IN_FAIL:
      return { ...state, isLoading: false, magicLinkSent: false }

    case types.SEND_MAGIC_LINK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        magicLinkSent: true
      }

    case types.RESET_SEND_MAGIC_LINK:
      return {
        ...state,
        isLoading: false,
        magicLinkSent: false
      }

    case types.SET_SSR_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload.isAuthenticated,
        token: action.payload.sub
      }

    default:
      return state
  }
}
